import {ReactNode} from "react";

type Props = {
    children?: ReactNode,
    className?: string,
    fluid?: boolean
}

const Container = ({fluid,className,children}: Props) => {

    return  <div className={`${fluid ? 'container-fluid' :'container'} ${className}`}>
        {children}
    </div>
}
export default Container;